import React, { useState, useEffect } from "react";

export function DotPattern() {
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024,
  );

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth < 768;
  const isTablet = windowWidth >= 768 && windowWidth < 1024;

  const W = 10; // Grid cell size
  const WIDTH = 4000; // Fixed width to ensure it covers the screen
  const COLS = Math.ceil(WIDTH / W) + 1;

  const patternScale = isMobile ? 0.4 : isTablet ? 0.7 : 1.0;

  return (
    <div className="absolute top-0 bottom-0 right-[-50vw] left-[10vw] md:right-[-25vw] md:left-[15vw] lg:left-[20vw] z-0 pointer-events-none overflow-hidden">
      <svg
        className="absolute inset-0 w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
      >
        <defs>
          <pattern
            id="halftone-pattern"
            x="0"
            y="0"
            width={WIDTH}
            height={W}
            patternUnits="userSpaceOnUse"
            patternTransform={`scale(${patternScale})`}
          >
            {Array.from({ length: COLS }).map((_, i) => {
              // Stretch horizontal pattern so max size is reached gradually near the right edge of the screen
              const maxCols = isMobile ? 95 : isTablet ? 130 : 180;
              const progress = Math.min(1.0, i / maxCols);

              // Max radius of W * 0.62 ensures circles overlap creating diamonds,
              // but don't become a solid gray color block. On mobile limit to 0.58 so circles don't merge completely into gray
              const rMax = isMobile ? W * 0.58 : W * 0.62;
              const r = Math.max(0.0, Math.pow(progress, 1.25) * rMax);
              const cx = i * W + W / 2;

              // If dots are too small, don't render to save performance
              if (r < 0.2) return null;

              return (
                <g key={i} className="dot-pattern-circle">
                  {/* Render 3 circles vertically to prevent clipping at the pattern top/bottom boundaries when r > W/2 */}
                  <circle cx={cx} cy={-W / 2} r={r} fill="currentColor" />
                  <circle cx={cx} cy={W / 2} r={r} fill="currentColor" />
                  <circle cx={cx} cy={W * 1.5} r={r} fill="currentColor" />
                </g>
              );
            })}
          </pattern>
          <linearGradient id="vertical-fade" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#fff" stopOpacity="0" />
            <stop offset="15%" stopColor="#fff" stopOpacity="1" />
            <stop offset="100%" stopColor="#fff" stopOpacity="1" />
          </linearGradient>
          <mask id="v-mask">
            <rect width="100%" height="100%" fill="url(#vertical-fade)" />
          </mask>
        </defs>
        <rect
          width="100%"
          height="100%"
          fill="url(#halftone-pattern)"
          mask="url(#v-mask)"
        />
      </svg>
    </div>
  );
}
